import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqImportarTablaEditar', {
    template: template,
    controller: NominasCargacontpaqImportarTablaEditarComponent,
    bindings: {
      concepto: '<',
      onClose: '&',
    },
  });

function NominasCargacontpaqImportarTablaEditarComponent($http) {
  let $ctrl = this;

  $ctrl.$onChanges = $onChanges;
  $ctrl.aceptar = aceptar;
  $ctrl.catalogo = {
    tiposValor: [
      {id: 1, descripcion: 'Texto'},
      {id: 2, descripcion: 'Decimal (2)'},
      {id: 3, descripcion: 'Entero'},
    ],
    indices: [
      {id: null, descripcion: 'Ninguno'},
      {id: 'id_colaborador', descripcion: 'ID colaborador (sistema)'},
      {id: 'codigo', descripcion: 'ID colaborador (cliente)'},
      {id: 'rfc', descripcion: 'RFC'},
      {id: 'curp', descripcion: 'CURP'},
    ],
  };
  $ctrl.cerrar = cerrar;
  $ctrl.seleccionarTipoValor = seleccionarTipoValor;

  function $onChanges(changes) {
    if (changes.concepto) {
      $ctrl.data = angular.copy($ctrl.concepto);
    }
  }

  function aceptar() {
    $ctrl.procesando = true;

    actualizar($ctrl.data.id)
      .then(function () {
        cerrar($ctrl.data);
      })
      .finally(function () {
        $ctrl.procesando = false;
      });
  }

  function actualizar(id) {
    let config = {
      params: {id: id},
      schema: {
        id: 'number',
        id_tipo_valor: 'number',
        identificador: 'boolean',
      },
    };

    return id
      ? $http.put('/api/nominas/carga-contpaqi/conceptos/concepto', $ctrl.data, config)
      : $http.post('/api/nominas/carga-contpaqi/conceptos', $ctrl.data, config);
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}});
  }

  function seleccionarTipoValor() {
    if ($ctrl.data.id_tipo_valor !== 0) {
      $ctrl.data.indice = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/importar/tabla/editar/component.js